export default __webpack_public_path__ + "static/media/calconvert_background_s1.a686ec6d.jpg";